<template>
  <nav :class="$style['sideNav']">
    <NavigationLink
      v-for="(item, index) in nav"
      :key="item.path"
      :to="{ name: item.path }"
    >
      <NavigationLinkContent
        :icon-name="item.icon"
        :nav-label="item.label"
        :is-active="index === activeIndex"
      />
    </NavigationLink>

    <a
      v-if="countryParams.CONTACT_URL !== '' && !blockedInExecution"
      :class="$style['link']"
      :href="countryParams.CONTACT_URL"
      target="_blank"
    >
      <NavigationLinkContent
        :icon-name="'IconMailHeart'"
        :nav-label="'contact'"
      />
    </a>

    <a
      v-if="countryParams.FAQ_URL !== ''"
      :class="$style['link']"
      :href="countryParams.FAQ_URL"
      target="_blank"
    >
      <NavigationLinkContent
        :icon-name="'IconQuestion'"
        :nav-label="'faq'"
      />
    </a>
  </nav>
</template>

<script lang="ts" setup>
import type { NavItem } from './NavItem.type';

const countryParams = await useCountryParams();

type Props = {
  nav: NavItem[];
};

const props = defineProps<Props>();

const store = useFloristInfoStore();
const { floristInfo: floristInfo } = storeToRefs(store);
const { blockedInExecution } = floristInfo.value?.floristActivity ?? {};

const route = useRoute();
const activeIndex = computed(() => props.nav.findIndex((item) => route.name === item.path));
</script>

<style lang="postcss" module>
.sideNav {
  @media (max-width: 900px) {
    display: none;
  }

  @media (min-width: 901px) {
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    max-width: 120px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--color-mono-100);
    box-shadow: var(--shadow-800);
    gap: var(--space-300);
  }
}

.link {
  text-decoration: none;
  color: var(--color-mono-500);
}
</style>
